// Client Portal-specific AG Grid cell renderers
// Only loaded by client portal pages, not main app

const I18n = window.I18n || {}

// Heroicons solid thumb icons (same as used in PropertyFeedbackButtons component)
const THUMBS_UP_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-[15px] h-[15px]">
  <path d="M7.493 18.5c-.425 0-.82-.236-.975-.632A7.48 7.48 0 0 1 6 15.125c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V3a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23h-.777ZM2.331 10.727a11.969 11.969 0 0 0-.831 4.398 12 12 0 0 0 .52 3.507C2.28 19.482 3.105 20 3.994 20H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 0 1-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227Z" />
</svg>`

const THUMBS_DOWN_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-[15px] h-[15px]">
  <path d="M15.73 5.5h1.035A7.465 7.465 0 0 1 18 9.625a7.465 7.465 0 0 1-1.235 4.125h-.148c-.806 0-1.534.446-2.031 1.08a9.04 9.04 0 0 1-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.499 4.499 0 0 0-.322 1.672v.633a.75.75 0 0 1-.75.75 2.25 2.25 0 0 1-2.25-2.25c0-1.152.26-2.243.723-3.218.266-.558-.107-1.282-.725-1.282H3.622c-1.026 0-1.945-.694-2.054-1.715A12.137 12.137 0 0 1 1.5 12.25c0-2.848.992-5.464 2.649-7.521C4.537 4.247 5.136 4 5.754 4H9.77a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23ZM21.669 14.023c.536-1.362.831-2.845.831-4.398 0-1.22-.182-2.398-.52-3.507-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898.591 1.2.924 2.55.924 3.977a8.958 8.958 0 0 1-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227Z" />
</svg>`

// Style constants for feedback icons (matches PropertyFeedbackButtons component)
// Tailwind colors: green-500=#22c55e, green-50=#f0fdf4, green-600=#16a34a
//                  red-500=#ef4444, red-50=#fef2f2, red-600=#dc2626
const FEEDBACK_ICON_COLORS = {
  thumbsUp: "#16a34a", // green-600
  thumbsDown: "#dc2626", // red-600
}

const TOUR_STATUS_COLORS = {
  completed: "#10b981", // green-500
  scheduled: "#3b82f6", // blue-500
  date: "#6b7280", // gray-500
}

function createThumbIcon(type) {
  const isThumbsDown = type === "down"
  const color = isThumbsDown
    ? FEEDBACK_ICON_COLORS.thumbsDown
    : FEEDBACK_ICON_COLORS.thumbsUp

  const wrapper = document.createElement("div")
  wrapper.innerHTML = isThumbsDown ? THUMBS_DOWN_SVG : THUMBS_UP_SVG
  wrapper.style.cssText = `
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${color};
  `
  wrapper.querySelector("svg").style.cssText = "width: 24px; height: 24px;"

  return wrapper
}

export class TourFeedbackCellRenderer {
  init(params) {
    this.params = params
    this.eGui = document.createElement("div")
    this.eGui.style.cssText = "display: flex; gap: 8px; align-items: center;"

    this.render()
  }

  render() {
    this.eGui.innerHTML = ""

    const tourStatus = this.params.data.tour_status
    const tourDate = this.params.data.tour_date
    const tourStatusLabel = this.params.data.tour_status_label

    // If there's a tour status label and date, show the tour status with date
    if (tourStatusLabel && tourDate) {
      const statusEl = document.createElement("div")
      statusEl.style.cssText = `
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-size: 12px;
        line-height: 1.2;
      `

      const color =
        tourStatus === "completed"
          ? TOUR_STATUS_COLORS.completed
          : TOUR_STATUS_COLORS.scheduled
      statusEl.innerHTML = `
        <span style="color: ${color}; font-weight: 500;">${tourStatusLabel}</span>
        <span style="color: ${TOUR_STATUS_COLORS.date};">${tourDate}</span>
      `

      this.eGui.appendChild(statusEl)
      return
    }

    // Fall back to showing thumbs up/down based on wants_tour
    const isThumbsUpActive = this.params.value === true
    const isThumbsDownActive = this.params.value === false

    if (isThumbsDownActive) {
      this.eGui.appendChild(createThumbIcon("down"))
    }
    if (isThumbsUpActive) {
      this.eGui.appendChild(createThumbIcon("up"))
    }
  }

  updateFeedback(wantsTour) {
    if (this.params.pushEvent) {
      this.params.pushEvent("update_feedback", {
        property_id: this.params.data.id,
        wants_tour: String(wantsTour),
      })
    }
  }

  getGui() {
    return this.eGui
  }

  refresh(params) {
    this.params = params
    this.render()
    return true
  }
}

export class LocationCellRenderer {
  init(params) {
    this.eGui = document.createElement("div")
    this.eGui.style.cssText =
      "display: flex; flex-direction: row; align-items: flex-start; gap: 8px; line-height: 1.3; padding: 4px 0;"

    // Reserve space for the orange dot on all rows to keep addresses aligned.
    // Filled orange for "needs review" properties, invisible otherwise.
    const dot = document.createElement("div")
    dot.style.cssText = `
      width: 8px; height: 8px; min-width: 8px; border-radius: 50%; margin-top: 4px;
      background-color: ${params.data.needs_review ? "#F97316" : "transparent"};
    `
    this.eGui.appendChild(dot)

    const textWrapper = document.createElement("div")
    textWrapper.style.cssText =
      "display: flex; flex-direction: column; justify-content: center; min-width: 0;"

    const address = params.value || ""
    const cityState = params.data.building_city_state || ""

    const addressEl = document.createElement("div")
    addressEl.textContent = address
    addressEl.style.cssText =
      "font-size: 12px; font-weight: 500; color: #111827; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
    textWrapper.appendChild(addressEl)

    if (cityState) {
      const cityStateEl = document.createElement("div")
      cityStateEl.textContent = cityState
      cityStateEl.style.cssText =
        "font-size: 10px; font-weight: 400; color: #8a9499; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      textWrapper.appendChild(cityStateEl)
    }

    this.eGui.appendChild(textWrapper)
  }

  getGui() {
    return this.eGui
  }

  refresh(params) {
    return false
  }
}

export class SubleaseCheckCellRenderer {
  init(params) {
    this.params = params
    this.eGui = document.createElement("div")
    this.eGui.style.cssText =
      "display: flex; align-items: center; justify-content: center; height: 100%;"

    if (params.value === true) {
      this.eGui.textContent = "✓"
      this.eGui.style.color = "#10b981"
    }
  }

  getGui() {
    return this.eGui
  }

  refresh(params) {
    return false
  }
}

export class PropertyActionsCellRenderer {
  init(params) {
    this.params = params
    this.eGui = document.createElement("div")
    this.eGui.style.cssText =
      "display: flex; gap: 4px; align-items: center; justify-content: center; height: 100%;"

    const hasBrochure = params.data.has_brochure

    if (hasBrochure) {
      // Document icon indicator (heroicons:document outline)
      const docIcon = document.createElement("div")
      docIcon.innerHTML = `
        <svg class="w-[15px] h-[15px]" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
      `
      docIcon.title = I18n["Brochure available"]
      docIcon.style.cssText = `
        color: #6b7280;
        display: flex;
        align-items: center;
        justify-content: center;
      `
      this.eGui.appendChild(docIcon)
    } else {
      const emptyDiv = document.createElement("div")
      emptyDiv.textContent = "-"
      emptyDiv.style.cssText = "color: #9ca3af; text-align: center;"
      this.eGui.appendChild(emptyDiv)
    }
  }

  getGui() {
    return this.eGui
  }

  refresh(params) {
    return false
  }
}
